export default __webpack_public_path__ + "static/media/Hair_6_M_C3.e4057fbb.svg";